// removed by extract-text-webpack-plugin
module.exports = {"gain-positive":"_2RMvWkErDCzmf_6TjtTojO","colored-numeral":"_21VY0UAZZBP_xzo0c7mtIH","block-numeral":"_1cQNLvkIGcMiQW02UEJXwz","gain-negative":"LTKkXbFRnZfArr3Vo7F8P","numeral":"_1_8tLUqjl5Z3x4ytC3PxLG","number":"_1ywV0eUuRlknwCqGFLNMsb","spin":"_1GZIpBMeQUp0OqBNnRvLYz"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/Numeral/styles.scss
// module id = 411
// module chunks = 18